import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "tui-image-editor/dist/tui-image-editor.css";
import ImageEditor from "@toast-ui/react-image-editor";
import React, { useContext, useRef } from "react";
import "./ImageEdit.css";
import { LanguageContext } from "../../utils/Language";

const myTheme = {
  // Theme object to extends default dark theme.
  "header.display": "none",
};

function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export default function ImageEdit(props) {
  const { dictionary } = useContext(LanguageContext);
  const editorRef = useRef();

  const handleSave = () => {
    const editorInstance = editorRef.current.getInstance();
    const dataURL = editorInstance.toDataURL();
    let file = dataURLtoFile(dataURL, props.imageId);
    const blob = dataURLtoBlob(dataURL);
    file.preview = URL.createObjectURL(blob);
    props.onSetEditedImage(props.imageId, file)
    props.onHide();
  };

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      id="image-edit"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton/>
      <Modal.Body className="image-editor">
        <ImageEditor
          ref={editorRef}
          includeUI={{
            loadImage: {
              path: props.imagePath,
              name: "SampleImage",
            },
            theme: myTheme,
            menu: ["crop", "flip", "rotate", "shape", "text"],
            initMenu: "shape",
            uiSize: {
              width: "1000px",
              height: "700px",
            },
            menuBarPosition: "bottom",
          }}
          cssMaxHeight={500}
          cssMaxWidth={700}
          selectionStyle={{
            cornerSize: 20,
            rotatingPointOffset: 70,
          }}
          usageStatistics={false}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          {dictionary["Cancel"]}
        </Button>
        <Button onClick={handleSave}>{dictionary["Save"]}</Button>
      </Modal.Footer>
    </Modal>
  );
}
